module.exports = __webpack_public_path__ + "static/media/Arts, Schilling, Prayer Chapel bricks.b70dbfae.png";